import { useQuery } from '@tanstack/react-query';
import QueryKeys from '@constants/queryKeys';
import { getJobAssignment } from '@worker/services/job/api';

interface UseJobAssignmentOptions {
  enabled?: boolean;
}

export const jobAssignmentKeys = {
  all: [QueryKeys.WORKER_ASSIGNMENT_JOB],
  detail: (id: number) => [QueryKeys.WORKER_ASSIGNMENT_JOB, id],
};

export function useJobAssignment(
  jobAssignmentId: number | null,
  options?: UseJobAssignmentOptions
) {
  return useQuery({
    queryKey:
      jobAssignmentId != null
        ? jobAssignmentKeys.detail(jobAssignmentId)
        : jobAssignmentKeys.all,
    queryFn: () => getJobAssignment(jobAssignmentId as number),
    enabled: (options?.enabled ?? true) && jobAssignmentId != null,
  });
}
